/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Display_RightInputs */



/**
* | output |
* | --- |
* | "Right" |
*
* @param {Input_Position_Display_RightInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_display_right = /** @type {((inputs?: Input_Position_Display_RightInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Display_RightInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giusto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Верно")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bien")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正确的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सही")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Certo")
	return /** @type {LocalizedString} */ ("Right")
});